// If you are adding a term to the Source glossary,
// please add a member of the Data team to your PR

// Due to overlap between the name property of Screen events and the
// source property of UI, Track, and Operational events, we group
// them together in this file.
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329599/Analytics+Lesson+1+-+Event+Types

// More information on naming screens:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329341/Screen+Events

// Inline dialogs (popovers) are components that pop up over the UI and provides additional functionality that involves user interaction.
const inlineDialogs = {
  aboutThisBoardAdminListInlineDialog: 'aboutThisBoardAdminListInlineDialog',
  accountSwitcherAddAccountInlineDialog:
    'accountSwitcherAddAccountInlineDialog',
  actionableTaskInlineDialog: 'actionableTaskInlineDialog',
  addListInlineDialog: 'addListInlineDialog',
  addToEnterpriseInlineDialog: 'addToEnterpriseInlineDialog',
  adminListInlineDialog: 'adminListInlineDialog',
  allBoardMembersInlineDialog: 'allBoardMembersInlineDialog',
  atlassianAccountMigrationChangeEmailInlineDialog:
    'atlassianAccountMigrationChangeEmailInlineDialog',
  attachmentGetPowerUpInlineDialog: 'attachmentGetPowerUpInlineDialog',
  attachmentsGetPowerUpUpgradeInlineDialog:
    'attachmentsGetPowerUpUpgradeInlineDialog',
  autoEnableCalendarInlineDialog: 'autoEnableCalendarInlineDialog',
  avatarChangeInlineDialog: 'avatarChangeInlineDialog',
  boardMenuDrawerEnterpriseUpsellInlineDialog:
    'boardMenuDrawerEnterpriseUpsellInlineDialog',
  boardOrganizationInlineDialog: 'boardOrganizationInlineDialog',
  boardPowerUpGettingStartedInlineDialog:
    'boardPowerUpGettingStartedInlineDialog',
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  boardViewsInlineDialog: 'boardViewsInlineDialog',
  cardComposerLabelSelectorInlineDialog:
    'cardComposerLabelSelectorInlineDialog',
  cardComposerMemberSelectorInlineDialog:
    'cardComposerMemberSelectorInlineDialog',
  cardComposerMenuInlineDialog: 'cardComposerMenuInlineDialog',
  cardComposerPositionSelectorInlineDialog:
    'cardComposerPositionSelectorInlineDialog',
  cardCoverInlineDialog: 'cardCoverInlineDialog',
  cardMemberListInlineDialog: 'cardMemberListInlineDialog',
  changeBillingContactInlineDialog: 'changeBillingContactInlineDialog',
  changeBoardOrganizationInlineDialog: 'changeBoardOrganizationInlineDialog',
  boardSidebarPupInlineDialog: 'boardSidebarPupInlineDialog',
  changeBoardPermissionsInlineDialog: 'changeBoardPermissionsInlineDialog',
  changeBoardVisibilityInlineDialog: 'changeBoardVisibilityInlineDialog',
  changeCreditCardInlineDialog: 'changeCreditCardInlineDialog',
  changeEmailInlineDialog: 'changeEmailInlineDialog',
  changeEmailSubmittedInlineDialog: 'changeEmailSubmittedInlineDialog',
  changeEmailWarningInlineDialog: 'changeEmailWarningInlineDialog',
  changeInvoiceDetailsInlineDialog: 'changeInvoiceDetailsInlineDialog',
  changeListFromTableInlineDialog: 'changeListFromTableInlineDialog',
  changeOrgInlineDialog: 'changeOrgInlineDialog',
  checkItemMenuInlineDialog: 'checkItemMenuInlineDialog',
  copyCardInlineDialog: 'copyCardInlineDialog',
  copyBoardInlineDialog: 'copyBoardInlineDialog',
  copyListInlineDialog: 'copyListInlineDialog',
  changeTeamAvatarDialog: 'changeTeamAvatarDialog',
  createCardFromTemplateInlineDialog: 'createCardFromTemplateInlineDialog',
  createFromTemplateInlineDialog: 'createFromTemplateInlineDialog',
  createMenuInlineDialog: 'createMenuInlineDialog',
  createMultipleCardsInlineDialog: 'createMultipleCardsInlineDialog',
  datePickerInlineDialog: 'datePickerInlineDialog',
  dueDateFilterInlineDialog: 'dueDateFilterInlineDialog',
  emailHygieneRemoveSecondaryEmailsInlineDialog:
    'emailHygieneRemoveSecondaryEmailsInlineDialog',
  emailHygieneChangeEmailInlineDialog: 'emailHygieneChangeEmailInlineDialog',
  emailToBoardSettingsInlineDialog: 'emailToBoardSettingsInlineDialog',
  exportBoardInlineDialog: 'exportBoardInlineDialog',
  filterTableByDueDateInlineDialog: 'filterTableByDueDateInlineDialog',
  filterTableByLabelInlineDialog: 'filterTableByLabelInlineDialog',
  filterTableByListInlineDialog: 'filterTableByListInlineDialog',
  filterTableByMemberInlineDialog: 'filterTableByMemberInlineDialog',
  inlineCardComposerInlineDialog: 'inlineCardComposerInlineDialog',
  inlineListComposerInlineDialog: 'inlineListComposerInlineDialog',
  inviteToBoardInlineDialog: 'inviteToBoardInlineDialog',
  inviteToTeamInlineDialog: 'inviteToTeamInlineDialog',
  labelFilterInlineDialog: 'labelFilterInlineDialog',
  linkCopyInlineDialog: 'linkCopyInlineDialog',
  listFilterInlineDialog: 'listFilterInlineDialog',
  listLimitInlineDialog: 'listLimitInlineDialog',
  listMenuInlineDialog: 'listMenuInlineDialog',
  mapCardComposerInlineDialog: 'mapCardComposerInlineDialog',
  memberFilterInlineDialog: 'memberFilterInlineDialog',
  memberMenuInlineDialog: 'memberMenuInlineDialog',
  miniProfileInlineDialog: 'miniProfileInlineDialog',
  moonshotWelcomeInlineDialog: 'moonshotWelcomeInlineDialog',
  moonshotPaymentScreen: 'moonshotPaymentScreen',
  moreMenuShareInlineDialog: 'moreMenuShareInlineDialog',
  moveAllCardsInListInlineDialog: 'moveAllCardsInListInlineDialog',
  moveListInlineDialog: 'moveListInlineDialog',
  newBoardHelperAddOrganizationInlineDialog:
    'newBoardHelperAddOrganizationInlineDialog',
  printAndExportBoardInlineDialog: 'printAndExportBoardInlineDialog',
  productPurchaseScreen: 'productPurchaseScreen',
  pupAttachmentSectionInlineDialog: 'pupAttachmentSectionInlineDialog',
  pupAttachmentsInlineDialog: 'pupAttachmentsInlineDialog',
  pupCardBackSectionInlineDialog: 'pupCardBackSectionInlineDialog',
  pupConfigurationInlineDialog: 'pupConfigurationInlineDialog',
  pupLimitBCUpsellInlineDialog: 'pupLimitBCUpsellInlineDialog',
  pupPopupInlineDialog: 'pupPopupInlineDialog',
  quickCardEditorInlineDialog: 'quickCardEditorInlineDialog',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  searchInlineDialog: 'searchInlineDialog',
  setPrimaryEmailInlineDialog: 'setPrimaryEmailInlineDialog',
  shareTemplateInlineDialog: 'shareTemplateInlineDialog',
  switchToYearlyBillingInlineDialog: 'switchToYearlyBillingInlineDialog',
  tacoTemplateTipsInlineDialog: 'tacoTemplateTipsInlineDialog',
  taxExemptionInlineDialog: 'taxExemptionInlineDialog',
  teamTemplatePicker: 'teamTemplatePicker',
  templateTipsInlineDialog: 'templateTipsInlineDialog',
  unplashCoverInlineDialog: 'unplashCoverInlineDialog',
  useTemplateInlineDialog: 'useTemplateInlineDialog',
  votingSettingsInlineDialog: 'votingSettingsInlineDialog',
  workspacesPreambleInlineDialog: 'workspacesPreambleInlineDialog',
  workspacesPreambleBoardInviteInlineDialog:
    'workspacesPreambleBoardInviteInlineDialog',
  workspacesPreambleAddToTeamInlineDialog:
    'workspacesPreambleAddToTeamInlineDialog',
} as const;

const sections = {
  teamTemplatePickerSection: 'teamTemplatePickerSection',
  teamGettingStartedHomeSectionItem: 'teamGettingStartedHomeSectionItem',
  twoFactorAuthSettings: 'twoFactorAuthSettings',
  yourItemsSection: 'yourItemsSection',
} as const;

// Modals are components that are independently brought to the foreground while
// dimming out the rest of the experience. They are NOT popovers!
const modals = {
  atlassianAutomaticOnboardingUpdateAccountModal:
    'atlassianAutomaticOnboardingUpdateAccountModal',
  atlassianAutomaticOnboardingProfileModal:
    'atlassianAutomaticOnboardingProfileModal',
  atlassianAutomaticOnboardingConfirmationModal:
    'atlassianAutomaticOnboardingConfirmationModal',
  atlassianAutomaticOnboardingEmailMismatchModal:
    'atlassianAutomaticOnboardingEmailMismatchModal',
  atlassianManagedAccountModal: 'atlassianManagedAccountModal',
  boardPowerUpDirectoryModal: 'boardPowerUpDirectoryModal',
  cancelBusinessClassModal: 'cancelBusinessClassModal',
  cancelTrelloGoldModal: 'cancelTrelloGoldModal',
  closedBoardsModal: 'closedBoardsModal',
  createBoardModal: 'createBoardModal',
  createFreeTeamModal: 'createFreeTeamModal',
  freeTeamRestrictionModal: 'freeTeamRestrictionModal',
  freeTrialModal: 'freeTrialModal',
  planSelectionModal: 'planSelectionModal',
} as const;

// Drawers are components that slide in from the side and take control of the
// screen, like the boards menu on the left.
const drawers = {
  boardsDrawer: 'boardsDrawer',
  boardMenuDrawer: 'boardMenuDrawer',
  boardSidebarDrawer: 'boardSidebarDrawer', // Deprecated, use a boardMenuDrawerScreen or the generic `boardMenuDrawer`
} as const;

// Banners are commonly displayed between the app header and the board header
const banners = {
  advancedChecklistEducationBanner: 'advancedChecklistEducationBanner',
  atlassianAccessAdBanner: 'atlassianAccessAdBanner',
  atlassianAccountAutomaticOnboarding: 'atlassianAccountAutomaticOnboarding',
  atlassianAccountAutomaticOnboardingBanner:
    'atlassianAccountAutomaticOnboardingBanner',
  atlassianAccountMigrationBanner: 'atlassianAccountMigrationBanner',
  atlassianAccountOnboardingBanner: 'atlassianAccountOnboardingBanner',
  atlassianManagedAccountBanner: 'atlassianManagedAccountBanner',
  boardLimitsDowngradeBanner: 'boardLimitsDowngradeBanner',
  browserWillBeUnsupportedBanner: 'browserWillBeUnsupportedBanner',
  emailHygieneBanner: 'emailHygieneBanner',
  emailVerificationBanner: 'emailVerificationBanner',
  enterpriseDeprovisioningBanner: 'enterpriseDeprovisioningBanner',
  enterpriseLicenseBanner: 'enterpriseLicenseBanner',
  freeTeamLimitWarningBanner: 'freeTeamLimitWarningBanner',
  freeTeamLimitRestrictedBanner: 'freeTeamLimitRestrictedBanner',
  freeTrialBanner: 'freeTrialBanner',
  personalBoardsOwnershipBanner: 'personalBoardsOwnershipBanner',
  invitedBanner: 'invitedBanner',
  loggedInPublicBoardBanner: 'loggedInPublicBoardBanner',
  newLocaleBanner: 'newLocaleBanner',
  overdueBanner: 'overdueBanner',
  setPasswordBanner: 'setPasswordBanner',
} as const;

// Screens that are tabs of the home page experience
const homeScreens = {
  memberBoardsHomeScreen: 'memberBoardsHomeScreen', // trello.com/:user/boards
  memberHomeScreen: 'memberHomeScreen', // trello.com for logged in user
  templateGalleryScreen: 'templateGalleryScreen', // trello.com/templates
  organizationBoardsHomeScreen: 'organizationBoardsHomeScreen', // trello.com/:orgname/home
} as const;

// Screens are pages or tabs of an experience
const screens = {
  aaMigrationPromptCreateAaScreen: 'aaMigrationPromptCreateAaScreen',
  aaMigrationWizardCheckInboxScreen: 'aaMigrationWizardCheckInboxScreen',
  aaMigrationWizardLogInScreen: 'aaMigrationWizardLogInScreen',
  aaMigrationWizardCreateScreen: 'aaMigrationWizardCreateScreen',
  aaMigrationWizardEmailMismatchScreen: 'aaMigrationWizardEmailMismatchScreen',
  acceptBoardInvitationScreen: 'acceptBoardInvitationScreen',
  acceptTeamInvitationScreen: 'acceptTeamInvitationScreen',
  archiveScreen: 'archiveScreen',
  blankScreen: 'blankScreen', // trello.com/blank
  boardDirectoryScreen: 'boardDirectoryScreen',
  boardDirectoryFeaturedScreen: 'boardDirectoryFeaturedScreen',
  boardDirectoryPowerUpDetailsScreen: 'boardDirectoryPowerUpDetailsScreen',
  boardDirectoryMadeByTrelloScreen: 'boardDirectoryMadeByTrelloScreen',
  boardMapPowerUpScreen: 'boardMapPowerUpScreen',
  boardMenuDrawerAboutScreen: 'boardMenuDrawerAboutScreen',
  boardMenuDrawerActivityScreen: 'boardMenuDrawerActivityScreen',
  boardMenuDrawerArchiveScreen: 'boardMenuDrawerArchiveScreen',
  boardMenuDrawerBackgroundScreen: 'boardMenuDrawerBackgroundScreen',
  boardMenuDrawerBackgroundColorsScreen:
    'boardMenuDrawerBackgroundColorsScreen',
  boardMenuDrawerBackgroundPhotosScreen:
    'boardMenuDrawerBackgroundPhotosScreen',
  boardMenuDrawerCollectionsScreen: 'boardMenuDrawerCollectionsScreen',
  boardMenuDrawerDefaultScreen: 'boardMenuDrawerDefaultScreen',
  boardMenuDrawerFilterScreen: 'boardMenuDrawerFilterScreen',
  boardMenuDrawerLabelsScreen: 'boardMenuDrawerLabelsScreen',
  boardMenuDrawerMoreScreen: 'boardMenuDrawerMoreScreen',
  boardMenuDrawerSettingsScreen: 'boardMenuDrawerSettingsScreen',
  boardMenuDrawerStickersScreen: 'boardMenuDrawerStickersScreen',
  boardScreen: 'boardScreen', // Use for board
  businessClassSignupFormScreen: 'businessClassSignupFormScreen',
  calendarViewScreen: 'calendarViewScreen',
  cardDetailScreen: 'cardDetailScreen', // Use for cardback
  cardLabelsScreen: 'cardLabelsScreen',
  closeBoardScreen: 'closeBoardScreen', // After closing a board, before deleting
  createFirstBoardScreen: 'createFirstBoardScreen', // trello.com/create-first-board
  createMenuScreen: 'createMenuScreen',
  emailHygieneAtlassianTrelloScreen: 'emailHygieneAtlassianTrelloScreen',
  emailHygieneAaMigrationScreen: 'emailHygieneAaMigrationScreen',
  emailHygieneConfirmEmailScreen: 'emailHygieneConfirmEmailScreen',
  emailHygieneChooseEmailScreen: 'emailHygieneChooseEmailScreen',
  emailHygieneClaimableWarningScreen: 'emailHygieneClaimableWarningScreen',
  emailHygieneConfirmationSentScreen: 'emailHygieneConfirmationSentScreen',
  emailHygieneErrorScreen: 'emailHygieneErrorScreen',
  emailHygieneThanksScreen: 'emailHygieneThanksScreen',
  enterpriseAdminDashboardScreen: 'enterpriseAdminDashboardScreen', // trello.com/e/:name/admin
  freeTrialSignupFormScreen: 'freeTrialSignupFormScreen',
  instantSearchScreen: 'instantSearchScreen',
  labelEditScreen: 'labelEditScreen',
  memberAccountScreen: 'memberAccountScreen', // trello.com/:user/account
  memberActivityScreen: 'memberActivityScreen', // trello.com/:user/activity
  memberBillingScreen: 'memberBillingScreen',
  memberCardsScreen: 'memberCardsScreen', // trello.com/:user/cards
  moonshotBCFreeTrialUpsellScreen: 'moonshotBCFreeTrialUpsellScreen',
  moonshotCreateTeamScreen: 'moonshotCreateTeamScreen',
  moonshotInviteMembersScreen: 'moonshotInviteMembersScreen',
  moonshotPaymentScreen: 'moonshotPaymentScreen',
  moonshotPlanSelectionScreen: 'moonshotPlanSelectionScreen',
  moonshotSignupScreen: 'moonshotSignupScreen',
  multiBoardTableViewScreen: 'multiBoardTableViewScreen',
  newUserOrientationScreen: 'newUserOrientationScreen',
  nonEnterpriseTeamScreen: 'nonEnterpriseTeamScreen',
  pageNotFoundErrorScreen: 'pageNotFoundErrorScreen', // Generic "Page not found" 404 screen
  powerUpEditScreen: 'powerUpEditScreen', // trello.com/power-ups/:id/edit
  powerUpsAdminScreen: 'powerUpsAdminScreen', // trello.com/power-ups/admin
  profileAndVisibilitySettingsScreen: 'profileAndVisibilitySettingsScreen',
  publicDirectoryAllCategoriesScreen: 'publicDirectoryAllCategoriesScreen',
  publicDirectoryMadeByTrelloScreen: 'publicDirectoryMadeByTrelloScreen', // trello.com/power-ups/made-by-trello
  publicDirectoryCategoryScreen: 'publicDirectoryCategoryScreen',
  publicDirectoryHomeScreen: 'publicDirectoryHomeScreen',
  publicDirectoryPowerUpDetailsScreen: 'publicDirectoryPowerUpDetailsScreen',
  publicDirectoryScreen: 'publicDirectoryScreen',
  publicDirectorySearchResultsScreen: 'publicDirectorySearchResultsScreen',
  publicPowerUpAddToBoardScreen: 'publicPowerUpAddToBoardScreen',
  publicPowerUpDetailsScreen: 'publicPowerUpDetailsScreen',
  savedSearchesScreen: 'savedSearchesScreen',
  savedSearchScreen: 'savedSearchScreen',
  searchScreen: 'searchScreen', // https://trello.com/search
  searchHelpScreen: 'searchHelpScreen',
  searchResultsScreen: 'searchResultsScreen',
  selectOrgToUpgradeScreen: 'selectOrgToUpgradeScreen',
  shortcutsScreen: 'shortcutsScreen',
  sortListInlineDialog: 'sortListInlineDialog',
  teamBillingScreen: 'teamBillingScreen',
  teamGettingStartedScreen: 'teamGettingStartedScreen',
  teamScreen: 'teamScreen',
  teamMembersScreen: 'teamMembersScreen',
  teamSettingsScreen: 'teamSettingsScreen',
  templateCategoryScreen: 'templateCategoryScreen',
  templatePickerSection: 'templatePickerSection',
  templateStoryPageScreen: 'templateStoryPageScreen',
  templatesSubmitScreen: 'templatesSubmitScreen', // trello.com/templates/submit
  trelloGoldSignupFormScreen: 'trelloGoldSignupFormScreen',
  organizationBoardsScreen: 'organizationBoardsScreen', // trello.com/:orgname/home
  organizationExportScreen: 'organizationExportScreen', // trello.com/:org/export
  organizationGettingStartedScreen: 'organizationGettingStartedScreen', // trello.com/:org/getting-started
  organizationGuestsScreen: 'organizationGuestsScreen', // trello.com/:org/members/guests
  organizationHighlightsScreen: 'organizationHighlightsScreen', // trello.com/:org/highlights
  organizationMembersScreen: 'organizationMembersScreen', // trello.com/:org/members
  organizationPowerUpsScreen: 'organizationPowerUpsScreen', // trello.com/:org/power-ups
  organizationReportsScreen: 'organizationReportsScreen', // trello.com/:org/reports
  orgProfileEditScreen: 'orgProfileEditScreen',
  unknownScreen: 'unknownScreen',
  welcomeScreen: 'welcomeScreen',
} as const;

const jswCrossflowSources = {
  jswLearnMoreInlineDialog: 'jswLearnMoreInlineDialog',
} as const;

const packages = {
  '@atlassiansox/feature-flag-web-client':
    '@atlassiansox/feature-flag-web-client',
  '@trello/atlassian-analytics': '@trello/atlassian-analytics',
  '@trello/feature-flag-client': '@trello/feature-flag-client',
  '@trello/graphql': '@trello/graphql',
  '@trello/service-worker': '@trello/service-worker',
} as const;

const routes = {
  // Routes that don't have a 1:1 mapping to a screen
  // or reroutes to an existing screen (search, /tasks)
  // web/packages/routes/src/routes.ts
  billingRoute: 'billingRoute',
  billingCardRoute: 'billingCardRoute',
  billingCardProductRoute: 'billingCardProductRoute',
  boardReferralRoute: 'boardReferralRoute',
  cardAndBoardRoute: 'cardAndBoardRoute',
  doubleSlashSearchRoute: 'doubleSlashSearchRoute',
  enterpriseAdminDashboardTabRoute: 'enterpriseAdminDashboardTabRoute',
  goSearchRoute: 'goSearchRoute',
  memberTasksRoute: 'memberTasksRoute',
  publicDirectoryRoute: 'publicDirectoryRoute',
  searchRoute: 'searchRoute',
  toSearchRoute: 'toSearchRoute',
  userOrOrgRoute: 'userOrOrgRoute',
} as const;

const otherSources = {
  addPowerUpButton: 'addPowerUpButton',
  appHeader: 'appHeader', // The global Trello header
  appStartup: 'appStartup',
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  atlassianAccountAutomaticOnboardingOverlay:
    'atlassianAccountAutomaticOnboardingOverlay',
  atlassianAdministrationPage: 'atlassianAdministrationPage',
  atlassianSwitcher: 'atlassianSwitcher',
  avalaraCertCaptureIntegration: 'avalaraCertCaptureIntegration',
  boardDirectory: 'boardDirectory',
  boardDirectorySearch: 'boardDirectorySearch',
  boardMap: 'boardMap',
  cardLabelFilter: 'cardLabelFilter',
  cardView: 'cardView',
  crossFlowOverlay: 'crossFlowOverlay',
  closeBoardLink: 'closeBoardLink',
  emailVerificationOverlay: 'emailVerificationOverlay',
  externalScriptLoader: 'externalScriptLoader',
  powerUpCardFromUrl: 'powerUpCardFromUrl',
  powerUpFormatUrl: 'powerUpFormatUrl',
  globalErrorHandler: 'globalErrorHandler',
  'lib:pluginBehavioralAnalytics': 'lib:pluginBehavioralAnalytics',
  'lib:featureFlagWebClient': 'lib:featureFlagWebClient',
  iframeIO: 'iframeIO',
  listFooter: 'listFooter',
  listHeader: 'listHeader',
  newUserOrientationCard: 'newUserOrientationCard',
  onboardingDialog: 'onboardingDialog',
  pluginSuggestionSection: 'pluginSuggestionSection',
  powerUpCard: 'powerUpCard',
  stickerHoverView: 'stickerHoverView',
  stickerEditView: 'stickerEditView',
  templates: 'templates',
  templatesTemplateCategory: 'templatesTemplateCategory',
  templatesTemplateStory: 'templatesTemplateStory',
  templatesTemplatesFeatured: 'templatesTemplatesFeatured',
  teamfulCollaborationSuccessMessage: 'teamfulCollaborationSuccessMessage',
  // This is current being used for the generic global error handler. The intention is to eventually replace 'unknown'
  // with a source automatically determined based on the URL. Using 'unknown' should be avoided wherever possible.
  unknown: 'unknown',
} as const;

export const Source = {
  ...inlineDialogs,
  ...modals,
  ...drawers,
  ...banners,
  ...homeScreens,
  ...screens,
  ...sections,
  ...jswCrossflowSources,
  ...packages,
  ...routes,
  ...otherSources,
} as const;

export type SourceType = typeof Source[keyof typeof Source];
